import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeClockAnimated = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 12,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("g", {
			"data-hand": "minute",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 20V11",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			"data-hand": "hour",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 20V14",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgTimeClockAnimated);
export default ForwardRef;
